import { defineComponent as _defineComponent } from 'vue'
import { AbSection, AbContainer, AbTitle, AbSectionLayout } from '../../../ui';
import { DEFAULT_SPACING, Spacing } from '../../../../helpers/shared-props';
import CardSectionAwardsGrid from './CardSectionAwardsGrid.vue';
import CardSectionAwardsSlider from './CardSectionAwardsSlider.vue';
import { TextAlign } from '../../../../types';

interface CardSectionAwardsItem {
  image?: string;
  alt?: string;
  text?: string;
  link?: string;
}

interface Props {
  id?: string;
  title?: string;
  awards: CardSectionAwardsItem[];
  isSlider?: boolean;
  spacing?: Spacing;
  textAlign?: TextAlign;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAwards',
  props: {
    id: null,
    title: null,
    awards: null,
    isSlider: { type: Boolean },
    spacing: { default: () => DEFAULT_SPACING },
    textAlign: { default: 'center' }
  },
  setup(__props: any) {



return { __sfc: true,AbSection, AbContainer, AbTitle, AbSectionLayout, CardSectionAwardsGrid, CardSectionAwardsSlider }
}

})